export default __webpack_public_path__ + "static/media/filter-controller.c9c83b19.svg";